import { useAbortableGet } from '../../board/api/useAbortableGet';
import type { MarketRawResponse } from './searchTypes';

export function useMarketRaw(marketId: string | null) {
    return useAbortableGet<MarketRawResponse>(
        marketId
            ? `/api/markets/search/market/${encodeURIComponent(marketId)}/raw`
            : null,
    );
}